import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';
import { getFirstAllowedPath } from '../auth/permissions';

export function AuthLayout() {
  const { isAuthenticated, user } = useAuthStore();
  const defaultPath = getFirstAllowedPath(user);

  // Only redirect if authenticated AND we have a valid landing page.
  // Do NOT force-logout when defaultPath is null — the user may have a
  // valid token but their role simply lacks explicit page-level 'view'
  // permissions (e.g. freshly assigned custom role, permissions still loading).
  if (isAuthenticated && defaultPath) {
    return <Navigate to={defaultPath} replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-900 via-brand-700 to-brand-500 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white tracking-tight">
            RD Phishing &amp; Simulation Tool
          </h1>
          <p className="text-blue-200 mt-2 text-sm">
            Phishing simulation and security awareness platform
          </p>
        </div>
        {/* Auth card */}
        <div className="bg-card rounded-2xl shadow-2xl p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
